import { useState, useEffect } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import axios from "axios";
import * as helpers from "../utils/utils.js";
import { useClientId } from '../context/context.js';

const apiBaseUrl = process.env.REACT_APP_API_URL;

export function useCustomer() {
  const clientId = useClientId();
  const queryClient = useQueryClient();

  const retrieveCustomerById = async (id) => {
    const { data } = await axios.get(`${apiBaseUrl}/clients/${clientId}/customers/${id}`);
    return data;
  };

  const retrieveCustomerCards = async (id) => {
    const { data } = await axios.get(`${apiBaseUrl}/clients/${clientId}/customers/${id}/cards`);
    return data;
  };

  const createCustomerRequest = async (customerData) => {
    const { data } = await axios.post(`${apiBaseUrl}/clients/${clientId}/customers`, customerData);
    return data;
  };

  const updateCustomerRequest = async ({ id, customerData }) => {
    const { data } = await axios.put(`${apiBaseUrl}/clients/${clientId}/customers/${id}`, customerData);
    return data;
  };

  const { mutateAsync: updateCustomer } = useMutation({
    mutationFn: updateCustomerRequest,
    onSuccess: (data) => {
      console.log('Customer updated:', data);
      queryClient.invalidateQueries({ queryKey: ['customerData'] });
    },
    onError: (error) => console.error("Error updating customer:", error),
  });

  return {
    retrieveCustomerById,
    retrieveCustomerCards,
    updateCustomer,
  };
}
  